import { render, staticRenderFns } from "./AttachmentSelectionDialog.vue?vue&type=template&id=649a8529&scoped=true&"
import script from "./AttachmentSelectionDialog.vue?vue&type=script&lang=js&"
export * from "./AttachmentSelectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a8529",
  null
  
)

export default component.exports